import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const FenixA320MarketingSeo = () => {
  return <FenixMarketingSeo variant="A320" />;
};

export const FenixA319MarketingSeo = () => {
  return <FenixMarketingSeo variant="A319" />;
};

export const FenixA321MarketingSeo = () => {
  return <FenixMarketingSeo variant="A321" />;
};

const FenixMarketingSeo = ({ variant }: { variant: "A320" | "A319" | "A321" }): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="No type rating? No problem">
        <Text fz="medium">
          The Fenix {variant} is a stunningly realistic simulation of a real Airbus {variant}.
          Without training on the real aircraft, it can be easy to forget critical procedures when
          operating in the simulator. <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Never forget to start the APU again">
        <Text fz="medium">
          Start with our {variant} checklist and make it your own using the web-based editor. Mix in
          checklist items from other popular addons, color-code important memory items, and download
          your checklist as a PDF. Checklists are saved in your browser, so you can come back and
          adjust them later, and you can easily share links to your checklists with others.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
